import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SettingsComponent from '../components/settings/SettingsComponent';
import _ from 'lodash';
import { gettext, getLanguage } from '../i18n/service';
import * as createUserActions from '../actions/createUserActions';
import * as appActions from '../actions/appActions';
import * as adminActions from '../actions/adminActions';
import * as fleetActions from '../actions/fleetOwnerActions';
import LoopbackHttp from '../businessLogic/LoopbackHttp.js';

export class SettingsContainer extends React.Component {
  constructor(props, context) {
    super(props, context);

    if (!localStorage.getItem('last_settings_tab'))
      localStorage.setItem('last_settings_tab', LoopbackHttp.isFleet ? gettext('COMPANY') : gettext('USER-PROFILE'));

    this.selectedMenuItem = localStorage.getItem('last_settings_tab');
    this.state={};
    props.appActions.startSpinner();
    props.appActions.getCountries();

    _.bindAll(this, ['selectMenuItem', 'getCityById', 'prepareUserList',
      'getCountryByCityId', 'getCountries', 'getCountryById', 'getCities', 'getVehicles', 'addBilling',
      'getDriversFromUsers', 'getDispatchersFromUsers', 'getOperatorsFromUsers', 'getDispatcherPlatformsFromUsers','getBuildNum']);
      this.getBuildNum();

  }

  getBuildNum() {
    fetch(`https://circleci.com/api/v1.1/recent-builds?circle-token=919c3edaadd2d87050cb6af83608a53770f81258`)
      .then((result) => result.json())
      .then(data => { this.setState({buildNum:data[0]}); });
  }

  componentDidMount() {
    this.props.appActions.getTimezones();
  }

  componentWillReceiveProps(nextProps, nextState) {
    if (nextProps.error && nextProps.error !== this.props.error) {
      return this.props.showMessage({
        message: nextProps.error.message,
        level: 'error'
      });
    }
    this.props.appActions.endSpinner();
  }

  getDriversFromUsers(teams) {
    let drivers = [];
    _.map(teams, (team) => {
      _.map(team.drivers, (driver) => {
        driver.role = 'driver';
        ////it's team id
        driver.teamId = team.id;
        drivers.push(driver);
      });
    });

    return drivers;
  }

  getDispatchersFromUsers(teams) {
    let dispatchers = [];
    _.map(teams, (team) => {
      _.map(team.dispatchers, (dispatcher) => {
        dispatcher.role = 'dispatcher';
        ////it's team id
        dispatcher.teamId = team.id;
        dispatchers.push(dispatcher);
      });
    });

    return dispatchers;
  }

  getDispatcherPlatformsFromUsers(teams) {
    let platforms = [];
    _.map(teams, (team) => {
      _.map(team.dispatcherPlatforms, (platform) => {
        platform.role = 'dispatcherPlatform';
        ////it's team id
        platform.teamId = team.id;
        platforms.push(platform);
      });
    });

    return platforms;
  }

  getOperatorsFromUsers(teams) {
    let operators = [];
    _.map(teams, (team) => {
      _.map(team.operators, (operator) => {
        operator.role = 'operator';
        ////it's team id
        operator.teamId = team.id;
        operators.push(operator);
      });
    });

    return operators;
  }

  prepareUserList(users) {

    let drivers = this.getDriversFromUsers(users);
    let operators = this.getOperatorsFromUsers(users);
    let dispatchers = this.getDispatchersFromUsers(users);
    let platforms = this.getDispatcherPlatformsFromUsers(users);
    this.props.fleetActions.addUsersToStore(drivers.concat(operators, dispatchers, platforms));
    this.forceUpdate();
  }

  addBilling() {
    return this.props.router.push('/pay');
  }

  getCityById(id) {
    if (typeof id === 'string') {
      let city = _.find(this.props.cities, { id: id });
      if (city && city.name)
        if(getLanguage()!=='en' && getLanguage() !=='ar')
          return city.name['en'];
        else
          return city.name[getLanguage()];
      else return 'Can not get city';
    } else {
      if (id && id.name)
        if(getLanguage()!=='en' && getLanguage() !=='ar')
          return id.name['en'];
        else
          return id.name[getLanguage()];
      else return 'Can not get city';
    }
  }

  getCountryByCityId(id) {
    let country = _.find(this.props.countries, { id: id });
    if (country && country.name)
      if(getLanguage()!=='en' && getLanguage() !=='ar')
        return country.name['en'];
      else
        return country.name[getLanguage()];
    else return 'Can not get country';
  }

  getCities(selectedCountryId, selectedCityId = undefined) {
    return _.map(this.props.cities, (city) => {
      if (selectedCountryId === city.countryId)
        return (
          <option value={city.id}
            selected={city.id === selectedCityId}>
            {this.getCityById(city.id)}
          </option>
        );

    });
  }

  getVehicles(selectedVehicleSize = undefined) {
    return _.map(this.props.vehicles, (vehicle) => (
      <option
        selected={selectedVehicleSize === vehicle.size}
        key={`vehicle_${vehicle.type}`} value={vehicle.size}>
        {vehicle.type}
      </option>
    ));
  }

  getCountryById(id) {
    if (typeof id === 'string') {
      let contry = _.find(this.props.countries, { id: id });
      if (contry && contry.name)
        if(getLanguage()!=='en' && getLanguage() !=='ar')
          return contry.name['en'];
        else
          return contry.name[getLanguage()];
      else return 'Can not get city';
    } else {
      if (id && id.name)
        if(getLanguage()!=='en' && getLanguage() !=='ar')
          return id.name['en'];
        else
          return id.name[getLanguage()];
      else return 'Can not get city';
    }
  }

  getCountries(selectedCityCountryId = undefined) {
    return _.map(this.props.countries, (country) => {
      return (
        <option value={country.id}>
          {country.name.en}
        </option>
      );
    });
  }

  selectMenuItem(menuItem) {
    localStorage.setItem('last_settings_tab', menuItem);
    this.selectedMenuItem = menuItem;
    this.forceUpdate();
  }

  render() {
    return (
      <div>
        <SettingsComponent
          users={this.props.users}
          fleets={this.props.fleets}
          companies={this.props.companies}
          selectedMenuItem={this.selectedMenuItem}
          selectMenuItem={this.selectMenuItem}
          showMessage={this.props.showMessage}
          cities={this.props.cities}
          countries={this.props.countries}
          vehicles={this.props.vehicles}
          fleetActions={this.props.fleetActions}
          createUserActions={this.props.createUserActions}
          appActions={this.props.appActions}
          adminActions={this.props.adminActions}
          company={this.props.company}
          account={this.props.account}
          teams={this.props.teams}
          getCityById={this.getCityById}
          getCountryByCityId={this.getCountryByCityId}
          pickUpPoints={this.props.pickUpPoints}
          getCountries={this.getCountries}
          getCountryById={this.getCountryById}
          getCities={this.getCities}
          getVehicles={this.getVehicles}
          addBilling={this.addBilling}
          router={this.props.router}
          cards={this.props.cards}
          orders={this.props.orders}
          bills={this.props.bills}
          fetchCityForInfo={this.fetchCityForInfo}
          cityForInfo={this.props.cityForInfo}
          renderModalForDetails={this.props.renderModalForDetails}
          timezones={this.props.timezones}
        />
        <div className="appVersion"><strong>DOOK v3.6.{this.state.buildNum ? this.state.buildNum.build_num : ''}</strong></div>

      </div>
    );
  }
}

SettingsContainer.propTypes = {
  showMessage: PropTypes.func.isRequired,
  createdUser: PropTypes.object
};

function mapStateToProps(state) {
  return {
    account: state.appReducer.account,
    orders: state.appReducer.orders,
    bills: state.appReducer.bills,
    groupages: state.appReducer.groupages,
    vehicles: state.appReducer.vehicles,
    cities: state.appReducer.cities,
    countries: state.appReducer.countries,
    company: state.appReducer.company,
    teams: state.appReducer.teams,
    createdUser: state.createUserReducer.createdUser,
    accountUpdated: state.appReducer.accountUpdated,
    teamUpdated: state.appReducer.teamUpdated,
    teamCreated: state.appReducer.teamCreated,
    teamDeleted: state.appReducer.teamDeleted,
    addedToTeam: state.appReducer.addedToTeam,
    removedFromTeam: state.appReducer.removedFromTeam,
    userDeleted: state.appReducer.userDeleted,
    users: state.appReducer.users,
    pickUpPoints: state.appReducer.pickUpPoints,
    cards: state.appReducer.cards,
    fleets: state.appReducer.fleets,
    companies: state.appReducer.companies,
    error: state.appReducer.error,
    cityForInfo: state.appReducer.cityForInfo,
    timezones: state.appReducer.timezones
  };
}

function mapDispatchToProps(dispatch) {
  return {
    appActions: bindActionCreators(appActions, dispatch),
    createUserActions: bindActionCreators(createUserActions, dispatch),
    adminActions: bindActionCreators(adminActions, dispatch),
    fleetActions: bindActionCreators(fleetActions, dispatch)

  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SettingsContainer);



// WEBPACK FOOTER //
// ./src/containers/SettingsContainer.js